import { AllEtlTraitsSchema } from "types/src/traits/etl/AllEtlTraits.trait";
import { z } from "zod";

export const AbstractEtlValidationSchema = AllEtlTraitsSchema.merge(z.object({}));

export type AbstractEtlValidation = z.infer<typeof AbstractEtlValidationSchema>
